import { MIXTURE } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(MIXTURE);
const actions = { ...rawActions, ...thunkFactory(MIXTURE, '/mistura_substancia/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(MIXTURE, initialState);

// SAGAS
const sagas = sagasFactory(MIXTURE, '/mistura_substancia');
export { sagas };
